import styled from 'styled-components';

export const ShareWrapper = styled.div<{ size: string }>`
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  border-radius: ${({ size }) => size};

  background: ${({ theme }) => theme.background};
  border: 1px solid ${({ theme }) => theme.borderColor};
  box-shadow: unset;
  cursor: pointer;

  transition:
    border-color 0.3s,
    box-shadow 0.3s,
    background 0.3s;

  &:hover {
    border-color: transparent;
    background: ${({ theme }) => theme.backgroundActive};
    box-shadow: ${({ theme }) => theme.boxShadow};
  }
`;
